import styled from 'styled-components';

export const TinyText = styled.span`
  color: ${({ theme }) => theme.colors['grey-light']};
  font-family: 'GothamNarrow';
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.125rem;
`;
